module.exports = __webpack_public_path__ + "static/favicon228-8fed7f1abdfa800f28fa78ab8af95bb7.png";